import React from 'react';
import loadPianoData from '../piano_pages_state_manager';

const SubscribePage = () => (
  <div className="piano-page-container subscribe">
    <div className="piano-offer-container" />
  </div>
);

SubscribePage.loadData = store => loadPianoData(store);

export default SubscribePage;
